
    <div class="outer">
        <div class="b b1"></div>
        <div class="b b2"></div>
        <div class="b b3"></div>
        <div class="center mobile">
            <div class="heading ">
                <div class="row" >
                    <div class="large">{{config?.faqF}}</div>
                </div>
                <div class="row" >
                    <div class="large">{{config?.faqA}}</div>
                </div>
                <div class="row" >
                    <div class="large">{{config?.faqQ}}</div>
                </div>
            </div>

        </div>
        <layout>
            <div class="container ">
                <div class="center desktop transform">
                    <div class="heading">
                        <div class="row" >
                            <div class="large">{{config?.faqF}}</div>
                        </div>
                        <div class="row" >
                            <div class="large">{{config?.faqA}}</div>
                        </div>
                        <div class="row" >
                            <div class="large">{{config?.faqQ}}</div>
                        </div>
                    </div>
        
                </div>
                <div class="lcol" >
                    <span class="question">{{config?.faqTitle1}}</span>
                    <span class="answer"> {{config?.faqBody1}}</span>
                </div>
                <div class="lcol" >
                    <span class="question">{{config?.faqTitle2}}</span>
                    <span class="answer">   {{config?.faqBody2}}</span>
                </div>
                <div class="lcol" > 
                    <span class="question">{{config?.faqTitle3}}</span>
                    <span class="answer">  {{config?.faqBody3}}</span>
                </div>
            </div>
        </layout>
        <layout>
            <div class="bottom">
                <span>{{config?.otherQuestions}}</span>
                <text-button routerLink="/contact-us">{{config?.navContactUs}}</text-button>
            </div>
        </layout>

    </div>